import React, { useState, useEffect } from "react";
import {
	Switch,
	CircularProgress,
	Tooltip,
	Box,
	Typography,
} from "@mui/material";
import {
	CalendarMonth as CalendarMonthIcon,
	List as ListIcon,
} from "@mui/icons-material";

export default function CalendarToggle({ calendarmode, setCalendarmode }) {
	let [submitting, setSubmitting] = useState(false);
  let color = "rgba(0, 0, 0, 0.87)";

	const toggleView = async () => {
		try {
      let viewmode = calendarmode;
      setSubmitting(true);
			setCalendarmode(!viewmode);
			setSubmitting(false);
		} catch (e) {
			setSubmitting(false);
		}
	};

	return (
		<Box
			sx={(theme) => ({
				position: "relative",
				display: "inline-block",
				fontSize: "18px",
				marginBottom: "3%",
				marginLeft: theme.spacing(2),
				"& svg": {
					color: color,
				},
			})}
		>
			<Tooltip
				title={calendarmode ? "Events Calendar View" : "Events List View"}
			>
				{submitting ? (
					<CircularProgress size={13} />
				) : (
					<>
						<Typography
							variant="h6"
							sx={(theme) => ({ marginBottom: theme.spacing(2) })}
						>
            <CalendarMonthIcon sx={{ paddingTop: '4%', paddingRight: '5%' }} size={16} />
							Calendar View
						<Switch
							checked={calendarmode}
							onChange={toggleView}
							inputProps={{ "aria-label": "Calendar View Switch" }}
							label="Calendar View"
              />
              </Typography>
					</>
				)}
			</Tooltip>
		</Box>
	);
}
